<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchPromotion } from '@/api/ballsports/base/promotion';

export default {
    name: "promotion-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchPromotion,
        }
    }
}
</script>
